import React, { useRef, useState } from "react";
import { Button } from "antd";
import { useRestApi } from "~/hooks";
import styles from "./reports-page.css";

const {
  ["container"]: containerClassName,
  ["download-buttons-container"]: downloadButtonsContainer,
} = styles as any;

type ReportType = "usage" | "assumptionsexclusions";

export const DownloadReportsPage = () => {
  const [downloading, setDownloading] = useState(false);
  const [downloadingAE, setDownloadingAE] = useState(false);
  const downloadRef = useRef<HTMLAnchorElement>();
  const restApi = useRestApi();

  const onDownload = async (type: ReportType) => {
    switch (type) {
      case "usage": {
        setDownloading(true);
        const useageDownloader = await restApi.downloadUsageReport();
        if (downloadRef.current) {
          await useageDownloader.download(downloadRef.current);
          setDownloading(false);
        }
        break;
      }
      case "assumptionsexclusions": {
        setDownloadingAE(true);
        const fileDownloader = await restApi.downloadAssumptionsExclusionsExport();
        if (downloadRef.current) {
          await fileDownloader.download(downloadRef.current);
          setDownloadingAE(false);
        }
        break;
      }
    }
  };

  return (
    <div className={downloadButtonsContainer}>
      <div className={containerClassName}>
        <div>A report of all created matters by users:</div>
        <Button onClick={() => onDownload("usage")} loading={downloading}>
          Download Usage
        </Button>
      </div>
      <div className={containerClassName}>
        <div>Export Assumptions and Exclusions Library:</div>
        <Button onClick={() => onDownload("assumptionsexclusions")} loading={downloadingAE}>
          Download Export
        </Button>
      </div>
      <a ref={(e) => (downloadRef.current = e || undefined)} />
    </div>
  );
};
